export default __webpack_public_path__ + "static/media/Dosen.6d839900.svg";